import axios from 'axios';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import backendUrl from '../../apiConfig';

export default function LoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            navigate("/admin");
        }
    }, [navigate]);

    const LoginHandler = async (e) => {
        e.preventDefault();
        try {
            console.log({ email, password })
            const resp = await axios.post(
                `${backendUrl}/auth/login`,
                { email, password },
                { headers: { "Content-Type": "application/json" } }
            );
            console.log("response from login :   => ", resp)
            if (resp.status === 200) {
                const token = resp.data.token;
                console.log(token)
                localStorage.setItem("jwtToken", token);
                navigate("/admin");
            } else {
                setError("Login failed. Please try again.");
            }
        } catch (err) {
            console.log("Error:", err);
            setError("Login failed. Please check your credentials.");
        }
    };

    return (
        <div className="min-h-screen flex bg-white">
            <div className="flex-1 flex items-center justify-center p-8">
                <div className="w-full max-w-sm">
                    {/* <div className="mb-8">
                        <svg
                            className="h-8 w-auto"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z" />
                            <path d="m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9" />
                            <path d="M12 3v6" />
                        </svg>
                    </div> */}
                    <h1 className="text-3xl text-black font-bold tracking-tight mb-2">Login to Your Account</h1>
                    <p className="text-slate-600 mb-8">Welcome back! Please enter your details.</p>
                    <form onSubmit={LoginHandler} className="space-y-4">
                        <input
                            type="email"
                            placeholder="Email"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full bg-white px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                            required
                            autoFocus
                        />
                        <input
                            type="password"
                            placeholder="Password"
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full bg-white px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                            required
                        />
                        <button
                            type="submit"
                            className="w-full bg-black hover:bg-slate-800 text-white py-2 rounded-lg transition-colors"
                        >
                            Login
                        </button>
                        {error && <p className="text-red-500 text-sm">{error}</p>}
                    </form>
                    <div className="mt-8 text-center">
                        <div className="text-sm text-black mb-4">OR</div>
                        <div className="space-y-3">
                            <button className="w-full flex items-center justify-center gap-2 border border-slate-200 rounded-lg px-3 py-2 text-sm font-medium hover:bg-slate-50 transition-colors">
                                <svg className="h-5 w-5" viewBox="0 0 24 24">
                                    <path
                                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                                        fill="#4285F4"
                                    />
                                    <path
                                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                                        fill="#34A853"
                                    />
                                    <path
                                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                                        fill="#FBBC05"
                                    />
                                    <path
                                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                                        fill="#EA4335"
                                    />
                                </svg>
                                Login with Google
                            </button>
                            <button className="w-full flex items-center justify-center gap-2 border border-slate-200 rounded-lg px-3 py-2 text-sm font-medium hover:bg-slate-50 transition-colors">
                                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z" />
                                </svg>
                                Login with Apple
                            </button>
                        </div>
                    </div>
                    <div className="mt-8 text-center text-sm text-slate-600">
                        Don't have an account?{" "}
                        <a href="/signup" className="text-black font-medium hover:underline">
                            Sign up
                        </a>
                    </div>
                </div>
            </div>
            <div className="hidden lg:flex flex-1  text-black items-center justify-center bg-amber-400 p-12">
                <div className="max-w-lg">
                    <h2 className="text-4xl font-bold mb-6">Welcome back to SpellTree</h2>
                    <p className="text-lg mb-8">
                        Log in to manage your SpellTree, share your content, and grow your audience.
                    </p>
                    <div className="grid grid-cols-3 gap-4">
                        <div className="bg-black/10 rounded-lg p-4">
                            <div className="font-medium mb-2">Manage</div>
                            <p className="text-sm">Update your links and profile</p>
                        </div>
                        <div className="bg-black/10 rounded-lg p-4">
                            <div className="font-medium mb-2">share</div>
                            <p className="text-sm">share all your work through one link</p>
                        </div>
                        <div className="bg-black/10 rounded-lg p-4">
                            <div className="font-medium mb-2">Optimize</div>
                            <p className="text-sm">Improve your online presence</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}